<div class="align-center orange">
  <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
</div>
<h1 mat-dialog-title class="align-center orange no-padding">Er du sikker på at du vil annullere ordren?</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog" (click)="cancel()">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content class="align-center orange">
  <p>
    {{ message }}
  </p>
  <form [formGroup]="form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="mdc-textarea-fix">
        <mat-label>Angiv årsag til annullering</mat-label>
        <textarea formControlName="note" rows="3" maxlength="250" matInput></textarea>
        <mat-hint align="end">
          <app-character-count [control]="noteControl" [maxlength]="250"></app-character-count>
        </mat-hint>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-slide-toggle color="primary" formControlName="resendToNewPartner">Send til ny partner</mat-slide-toggle>
    </div>
    @if (resendToNewPartner.value) {
      <div class="form-row">
        <app-partner-active-input [form]="form" [partners]="activePartners$ | async" [produktId]="produkt"></app-partner-active-input>
      </div>
    }
  </form>
</div>
<div mat-dialog-actions class="row-reverse" class="align-center">
  <button mat-raised-button color="primary" (click)="create()" cdkFocusInitial [disabled]="form.invalid">Ja</button>
  <button mat-raised-button (click)="cancel()">Nej</button>
</div>
